// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.main-content-header {
  margin-top: -25px !important;
}

.image-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  /* Bil á milli mynda */
  justify-content: center;
  /* Miðja myndirnar lárétt */
}

.image-container a {
  display: block;
  /* Tryggir að slóðir fylgi réttri uppsetningu */
  flex: 1 1 calc(20% - 16px);
  /* 5 myndir í röð */
  max-width: calc(20% - 16px);
  text-decoration: none;
  /* Fjarlægir undirstrikun á slóðum */
}

.image-container img {
  width: 100%;
  /* Tryggir að myndir haldist innan foreldraíláts */
  height: auto;
  max-height: 50px;
  border-radius: 8px;
  object-fit: contain;
  /* Passar myndir innan foreldris */
}

:host {
  display: block;
}

.mat-expansion-panel-header {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.mat-expansion-panel-body {
  padding: 1rem 0.75rem 1.25rem 0.75rem;
}

.primary-color {
  color: var(--primary, #e91e63);
}

/* Minna bil milli panela */
.ef-accordion__panel {
  margin-bottom: 0px;
  /* var 12–16px áður */
}

/* Minni hæð og þéttara header */
.ef-accordion__header {
  /* var 64px */
  padding: 0 24px 0 8px;
  /* meiri hægri padding til að færa ör frá brún */
}

/* Færa ör (toggle-indicator) örlítið inn frá brún */
.ef-accordion .mat-expansion-indicator {
  margin-right: 6px;
  /* default ~0; bætum smá bil við */
}

/* Minka innri body-padding til að halda heildarþéttleika */
::ng-deep .ef-accordion .mat-expansion-panel-body {
  padding: 12px 16px 16px 16px;
  /* aðeins minna en default */
}

/* Valfrjálst: smávægileg border-lína eins og á verðskráarsíðunni */
.ef-accordion__panel {
  border-radius: 2px;
  /* minna radius til að líkjast dæminu */
  /* ef þú vilt alveg beinar brúnir: settu 0 */
}

.separator-line {
  margin: 5px 0px !important;
}

.main-content-header {
  background: radial-gradient(circle at top left, rgba(230, 240, 255, 0.8), transparent 70%), radial-gradient(circle at bottom right, rgba(230, 240, 255, 0.8), transparent 70%), #ffffff !important;
  min-height: 100%;
}

@media (max-width: 1200px) {
  .image-container a {
    flex: 1 1 calc(33.333% - 16px);
    /* 3 myndir í röð */
    max-width: calc(33.333% - 16px);
  }
}
@media (max-width: 768px) {
  .image-container a {
    flex: 1 1 calc(50% - 16px);
    /* 2 myndir í röð */
    max-width: calc(50% - 16px);
  }
}
@media (max-width: 480px) {
  .image-container a {
    flex: 1 1 100%;
    /* 1 mynd í röð */
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/pages/about-sell/about-sell.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,4BAAA;AAEF;;AACA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AAEF;;AACA;EACE,cAAA;EACA,+CAAA;EACA,0BAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,oCAAA;AAEF;;AACA;EACE,WAAA;EACA,kDAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kCAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,oBAAA;EACA,qBAAA;AAEF;;AACA;EACE,qCAAA;AAEF;;AACA;EACE,8BAAA;AAEF;;AACA,2BAAA;AACA;EACE,kBAAA;EACA,qBAAA;AAEF;;AACA,gCAAA;AACA;EACE,aAAA;EACA,qBAAA;EACA,gDAAA;AAEF;;AACA,oDAAA;AACA;EACE,iBAAA;EACA,kCAAA;AAEF;;AACA,2DAAA;AACA;EACE,4BAAA;EACA,4BAAA;AAEF;;AACA,mEAAA;AACA;EACE,kBAAA;EACA,uCAAA;EACA,4CAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,kMAAA;EAOA,gBAAA;AAJF;;AAOA;EACE;IACE,8BAAA;IACA,mBAAA;IACA,+BAAA;EAJF;AACF;AAOA;EACE;IACE,0BAAA;IACA,mBAAA;IACA,2BAAA;EALF;AACF;AAQA;EACE;IACE,cAAA;IACA,iBAAA;IACA,eAAA;EANF;AACF","sourcesContent":[".main-content-header {\r\n  margin-top: -25px !important;\r\n}\r\n\r\n.image-container {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 16px;\r\n  /* Bil á milli mynda */\r\n  justify-content: center;\r\n  /* Miðja myndirnar lárétt */\r\n}\r\n\r\n.image-container a {\r\n  display: block;\r\n  /* Tryggir að slóðir fylgi réttri uppsetningu */\r\n  flex: 1 1 calc(20% - 16px);\r\n  /* 5 myndir í röð */\r\n  max-width: calc(20% - 16px);\r\n  text-decoration: none;\r\n  /* Fjarlægir undirstrikun á slóðum */\r\n}\r\n\r\n.image-container img {\r\n  width: 100%;\r\n  /* Tryggir að myndir haldist innan foreldraíláts */\r\n  height: auto;\r\n  max-height: 50px;\r\n  border-radius: 8px;\r\n  object-fit: contain;\r\n  /* Passar myndir innan foreldris */\r\n}\r\n\r\n:host {\r\n  display: block;\r\n}\r\n\r\n.mat-expansion-panel-header {\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n}\r\n\r\n.mat-expansion-panel-body {\r\n  padding: 1rem 0.75rem 1.25rem 0.75rem;\r\n}\r\n\r\n.primary-color {\r\n  color: var(--primary, #e91e63); // fall-back ef theme vantar\r\n}\r\n\r\n/* Minna bil milli panela */\r\n.ef-accordion__panel {\r\n  margin-bottom: 0px;\r\n  /* var 12–16px áður */\r\n}\r\n\r\n/* Minni hæð og þéttara header */\r\n.ef-accordion__header {\r\n  /* var 64px */\r\n  padding: 0 24px 0 8px;\r\n  /* meiri hægri padding til að færa ör frá brún */\r\n}\r\n\r\n/* Færa ör (toggle-indicator) örlítið inn frá brún */\r\n.ef-accordion .mat-expansion-indicator {\r\n  margin-right: 6px;\r\n  /* default ~0; bætum smá bil við */\r\n}\r\n\r\n/* Minka innri body-padding til að halda heildarþéttleika */\r\n::ng-deep .ef-accordion .mat-expansion-panel-body {\r\n  padding: 12px 16px 16px 16px;\r\n  /* aðeins minna en default */\r\n}\r\n\r\n/* Valfrjálst: smávægileg border-lína eins og á verðskráarsíðunni */\r\n.ef-accordion__panel {\r\n  border-radius: 2px;\r\n  /* minna radius til að líkjast dæminu */\r\n  /* ef þú vilt alveg beinar brúnir: settu 0 */\r\n}\r\n\r\n.separator-line {\r\n  margin: 5px 0px !important;\r\n}\r\n\r\n.main-content-header {\r\n  background: radial-gradient(circle at top left,\r\n      rgba(230, 240, 255, 0.8),\r\n      transparent 70%),\r\n    radial-gradient(circle at bottom right,\r\n      rgba(230, 240, 255, 0.8),\r\n      transparent 70%),\r\n    #ffffff !important;\r\n  min-height: 100%;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .image-container a {\r\n    flex: 1 1 calc(33.333% - 16px);\r\n    /* 3 myndir í röð */\r\n    max-width: calc(33.333% - 16px);\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .image-container a {\r\n    flex: 1 1 calc(50% - 16px);\r\n    /* 2 myndir í röð */\r\n    max-width: calc(50% - 16px);\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .image-container a {\r\n    flex: 1 1 100%;\r\n    /* 1 mynd í röð */\r\n    max-width: 100%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
